import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import DataTable from 'react-data-table-component';
import ItemsService from "./Item.service.js";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import { Tooltip } from "@mui/material";
import VariationsFilter from "../../components/Table Filters/StocksFilter";
import AddStockModal from "./AddStock";
import UpdateStockModal from "./UpdateStockModal";
import BulkImportStockModal from "./BulkImportStockModal";
import PermissionAccess from '../../PermissionAccess/Access.js';

const TabAttribute = (state) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [Variations, setVariations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [showAddStockModal, setShowAddStockModal] = useState(false);
  const [showUpdateStockModal, setShowUpdateStockModal] = useState(false);
  const [currentStock, setCurrentStock] = useState(null);
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);
  const { authData,super_admin } = PermissionAccess();
// console.log('state--->',state);
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchData(currentPage, pageLimit);
  }, [pageLimit, currentPage]);

  const fetchData = (page, limit, text, status) => {
    setLoading(true);
    const offset = (page - 1) * limit;
    ItemsService.Get_Item_Stocks(offset, limit, state.state._id, authData.sessionID,authData.userData._id, text, status, true,super_admin).then(
      (response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
        } else {
          setVariations(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Server Error, Please try again later."));
      }
    );
  };

  const handleToggleAddStockModal = () => {
    setShowAddStockModal(!showAddStockModal);
  };

  const handleAddStockSuccess = () => {
    setShowAddStockModal(false);
    fetchData(currentPage, pageLimit, filterText, filterStatus);
  };

  const handleOpenUpdateModal = (stockData) => {
    setCurrentStock(stockData);
    setShowUpdateStockModal(true);
  };

  const handleCloseUpdateModal = () => {
    setShowUpdateStockModal(false);
    setCurrentStock(null);
  };

  const handleToggleBulkImportModal = () => {
    setShowBulkImportModal(!showBulkImportModal);
  };

  const handleBulkImportSuccess = () => {
    setShowBulkImportModal(false);
    fetchData(currentPage, pageLimit, filterText, filterStatus);
  };

  const handleDeleteSelected = () => {
    if (selectedRows.length > 0) {
      let msg = t(selectedRows.length + " records selected. Once deleted, you will not be able to recover this!");
      Alerts.swalConfirmDeleteAlert(msg).then(res => {
        if (res === true) {
          sendBulkDelete(selectedRows);
        }
      });
    } else {
      Alerts.swalErrorAlert('No records selected');
    }
  };

  const sendBulkDelete = (selectedRows) => {
    setLoading(true);
    ItemsService.DeleteBulkStocks(selectedRows, authData.sessionID).then((response) => {
      setLoading(false);
      setSelectedRows([]);
      fetchData(currentPage, pageLimit, filterText, filterStatus);
      if (response.data.status) {
        Alerts.swalSuccessAlert(response.data.message || t("Data Deleted Successfully."));
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
        } else {
          Alerts.swalErrorAlert(response.data.message || t("Error: Can't delete the Collection Data at the moment."));
        }
      }
    }).catch((error) => {
      setLoading(false);
      Alerts.swalErrorAlert(t("Delete operation failed"));
    });
  };

  // Add the missing functions
  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRows(Variations.map((variation) => variation._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRows((prevSelected) => [...prevSelected, row._id]);
    } else {
      setSelectedRows((prevSelected) => prevSelected.filter(id => id !== row._id));
    }
  };

  const handleSuccess = () => {
    fetchData(currentPage, pageLimit, filterText, filterStatus);
  };

  const confirmDelete = (id) => {
    let msg = t("Once deleted, you will not be able to recover!");
    Alerts.swalConfirmDeleteAlert(msg).then(res => {
      if (res === true) {
        sendDelete(id);
      }
    });
  };

  const sendDelete = (id) => {
    setLoading(true);
    ItemsService.DeleteStock(id, authData.sessionID).then((response) => {
      setLoading(false);
      fetchData(currentPage, pageLimit, filterText, filterStatus);
      if (response.data.status) {
        Alerts.swalSuccessAlert(response.data.message || t("Data Deleted Successfully."));
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
        } else {
          Alerts.swalErrorAlert(response.data.message || t("Error: Can't delete the Attribute."));
        }
      }
    }).catch((error) => {
      setLoading(false);
      Alerts.swalErrorAlert(t("Delete operation failed"));
    });
  };

  const mycolumns = [
    {
      name: (
        <div>
          <input
            className="form-check-input"
            type="checkbox"
            onChange={handleSelectAllChange}
          />
        </div>
      ),
      width: '5%',
      selector: (row) => {
        return (
          <div>
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleCheckboxChange(e, row)}
            />
          </div>
        );
      },
    },
    {
      name: t('Quantity'),
      selector: (row) => row.quantity,
      width: "20%",
      sortable: true,
    },

    {
      name: t('Price'),
      selector: (row) => row.price,
      width: "20%",
      sortable: true,
    },


    {
      name: t('Expiry Date'),
      selector: (row) => row.expiry_date,
      width: "20%",
      sortable: true,
    },
    {
      name: t('Status'),
      width: '20%',
      selector: (row) => {
        return (
          <div>
            {row.status.toLowerCase() === "active" ? (
              <button
                type="button"
                style={{ borderColor: '#3ac47d', backgroundColor: '#1BD35A' }}
                className="btn btn-sm btn-success btn-hover-shine me-3"
              >
                {row.status}
              </button>
            ) : (
              <button
                type="button"
                style={{ borderColor: '#FF0000', backgroundColor: 'red' }}
                className="btn btn-sm btn-danger btn-hover-shine me-3"
              >
                {row.status}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: t('Actions'),
      width: "15%",
      selector: (row) => {
        return (
          <div>
            <Tooltip placement="top" title={`${t("Update")} ${t("Item's")} ${t("Stock")}`} arrow>
          <i style={{ marginLeft: '10px', marginRight: '10px', cursor: 'pointer' }} onClick={() => handleOpenUpdateModal(row)}>
            <i className="pe-7s-pen text-primary btn-icon-wrapper fs-5"> </i>
          </i>
        </Tooltip>
            <Tooltip placement="top" title={`${t("Delete")} ${t("Item's")} ${t("Stock")}`} arrow>
              <a className="DeletetData" onClick={() => confirmDelete(row._id)} style={{ cursor: "pointer" }}>
                <i className="pe-7s-trash text-danger btn-icon-wrapper fs-5"> </i>
              </a>
            </Tooltip>
          </div>
        );
      }
    },
  ];

  const handleSearch = (searchText, status) => {
    setFilterText(searchText);
    setFilterStatus(status);
    setCurrentPage(1);
    fetchData(1, pageLimit, searchText, status);
  };

  const handleClear = () => {
    setFilterText('');
    setFilterStatus('');
    setCurrentPage(1);
    fetchData(1, pageLimit);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <VariationsFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterText={filterText}
        filterStatus={filterStatus}
      />
    );
  }, [filterText, filterStatus]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, pageLimit, filterText, filterStatus);
  };

  const handlePerRowsChange = async (newLimit, page) => {
    setPageLimit(newLimit);
    fetchData(page, newLimit, filterText, filterStatus);
  };

  return (
    <Fragment>
      <Col md="12" className="mx-auto app-login-box">
        <Row>
          <LoadingOverlay
            active={loading}
            spinner={<DNALoader />}
          >
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                    {subHeaderComponentMemo}
                  </Col>
                  <DataTable
                    data={Variations}
                    columns={mycolumns}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationResetDefaultPage={resetPaginationToggle}
                    subHeader
                    subHeaderComponent={
                      <div>
                        <button type="button"
                          className="btn btn-outline-danger btn-hover-shine me-3 btn"
                          onClick={handleDeleteSelected}
                        >
                          {t('Delete Selected')}
                        </button>

                        <button type="button"
                          className="btn btn-custom-color btn-hover-shine me-3 btn"
                          onClick={handleToggleAddStockModal}
                        >
                          {t('Add Stock')}
                        </button>

                        <button type="button"
                          className="btn btn-custom-color btn-hover-shine me-3 btn"
                          onClick={handleToggleBulkImportModal}
                        >
                          {t('Bulk Import')}
                        </button>
                        
                      </div>
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </LoadingOverlay>
        </Row>
      </Col>

      <AddStockModal
        showModal={showAddStockModal}
        handleToggleModal={handleToggleAddStockModal}
        onSuccess={handleAddStockSuccess}
        sessionID={authData.sessionID}
        pharmacyID={authData.userData._id}
        itemId={state.state._id}
        businessId={state.state.business_id}
      />

      <UpdateStockModal
        showModal={showUpdateStockModal}
        handleToggleModal={handleCloseUpdateModal}
        onSuccess={handleSuccess}
        sessionID={authData.sessionID}
        stockData={currentStock}
      />

    <BulkImportStockModal
        showModal={showBulkImportModal}
        handleToggleModal={handleToggleBulkImportModal}
        onSuccess={handleBulkImportSuccess}
        sessionID={authData.sessionID}
        itemId={state.state._id}
        businessId={state.state.business_id}
        pharmacyId={authData.userData._id}
      />

    </Fragment>
  );
};

export default TabAttribute;